import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  FiUser, FiHome, FiPlusSquare, FiShoppingBag, 
  FiUsers, FiTrash2, FiSettings, FiLogIn, FiLogOut, FiChevronDown 
} from 'react-icons/fi';
import './Adminnav.css';

const Adminnav = () => {
  const [adminName, setAdminName] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadAdminName = () => {
      const storedAdminName = localStorage.getItem('adminName');
      setAdminName(storedAdminName || '');
    };

    loadAdminName();
    const interval = setInterval(loadAdminName, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('adminName');
    localStorage.removeItem('adminToken'); 
    setAdminName('');
    navigate('/admin/0083/login');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.admin-profile')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="admin-navbar">
      <div className="navbar-container">
        <div className="hamburger-menu" onClick={toggleMenu}>
          <div className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></div>
        </div>
        
        <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <NavLink to="/admin/0083/home" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiHome /> Home
          </NavLink>
          <NavLink to="/admin/uploadproducts" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiPlusSquare /> Add Products
          </NavLink>
          <NavLink to="/admin/added-products" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiShoppingBag /> Products
          </NavLink>
          <NavLink to="/admin/customers" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiUsers /> Customers
          </NavLink>
          <NavLink to="/admin/deleted-orders" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiTrash2 /> Deleted Orders
          </NavLink>
          <NavLink to="/0083/adminsettings" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiSettings /> Settings
          </NavLink>
          <NavLink to="/0083/siteadmins" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
            <FiUsers /> Admins
          </NavLink>
          
          <div className="admin-section">
            {adminName ? (
              <div className="admin-profile">
                <button className="profile-toggle" onClick={toggleDropdown}>
                  <FiUser className="userIcon" /> {adminName} <FiChevronDown className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} />
                </button>
                <div className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
                  <button onClick={handleLogout} className="dropdown-item">
                    <FiLogOut /> Logout
                  </button>
                </div>
              </div>
            ) : (
              <NavLink to="/admin/0083/login" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>
                <FiLogIn /> Login
              </NavLink>
            )}

          </div>
        </div>
      </div>
    </nav>
  );
};

export default Adminnav;
